import { render, staticRenderFns } from "./BusinessGuide.vue?vue&type=template&id=5680cfde&scoped=true"
import script from "./BusinessGuide.vue?vue&type=script&lang=js"
export * from "./BusinessGuide.vue?vue&type=script&lang=js"
import style0 from "./BusinessGuide.vue?vue&type=style&index=0&id=5680cfde&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5680cfde",
  null
  
)

export default component.exports